<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import appointmentsApi from '@/services/api/appointments.api'
import locationApi from '@/services/api/location.api'
import providerApi from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Coordinación CSEE',
      routes: ["Informes", "Informe de Coordinación CSEE"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          periods: [],
          centers: [],
          providers: [],
        },
        filters: {
          academicYear: null,
          period: null,
          center: null,
          provider: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        clearable: false,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onChangeAcademicYear,
      },
      {
        name: 'period',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Periodo',
        placeholder: 'Seleccionar Periodo',
        clearable: false,
        options: this.model.search.collections.periods,
        value: this.model.search.filters.period,
        
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'CSEE',
        placeholder: 'Seleccionar',
        clearable: false,
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        disabled: this.model.search.collections.centers.length <= 0,
      },
      {
        name: 'provider',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        placeholder: 'Seleccionar',
        options: this.model.search.collections.providers,
        value: this.model.search.filters.provider,
        class: 'col-md-6',
        disabled: this.model.search.collections.providers.length <= 0,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);
    },
    async onChangeAcademicYear() {
      this.model.search.filters.period = null;
      this.model.search.filters.center = null;
      this.model.search.filters.provider = null;

      await this.getPeriod();
      await this.getCenter();
      await this.getProvider();

    },
    async getPeriod(){
      await appointmentsApi.getAppointmentsFilters({ academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => { 
        this.model.search.collections.periods = res.data;

      });
    },
    async getCenter(){
      await locationApi.getCenters({ academicYearId: this.model.search.filters.academicYear?.id})
        .then(res =>{ 
        this.model.search.collections.centers = res.data

      });
    },
    async getProvider(){
      await providerApi.getAllProvidertCompaniesByYear({ academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => { 
        this.model.search.collections.providers = res.data;

      });
    },
    async onHandlerSearch() {
      this.process();
    },
    async process() {
        await ReportServices.getReport('reportcoordinationcsee', {
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId : this.model.search.filters.center?.id,
        monthNumber: this.model.search.filters.period?.id,
        companyId: this.model.search.filters.provider?.id,
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>